import theme from 'theme';
import { FsComponentSize } from 'globals/types';

export const getRowPaddingRelativeValue = (size: FsComponentSize): string => {
  switch (size) {
    case FsComponentSize.XS:
      return theme.spacing(0, 0);
    case FsComponentSize.S:
      return theme.spacing(1, 1);
    case FsComponentSize.M:
      return theme.spacing(2, 2);
    case FsComponentSize.L:
      return theme.spacing(3, 2);
    default:
      return theme.spacing(3, 2);
  }
};
